<div class="pinned-thread-rail" *ngIf="getPinnedThread() as pinnedThread">
  <div
    class="pinned-thread-resize-handle"
    (mousedown)="onPinnedResizeStart($event)"
    [uiTooltip]="'Resize pinned thread'"
    uiTooltipPlacement="right"
    [uiTooltipSuppressOnMobile]="true">
    <span class="pinned-thread-resize-grip"></span>
  </div>

  <div class="pinned-thread-shell" [class.theme-light]="theme.isLight">
    <div class="pinned-thread-header" (mousedown)="onFocusThread(pinnedThread.threadId)">
      <div class="pinned-thread-heading">
        <div class="pinned-thread-title">
          Agent
        </div>
      </div>
    </div>

    <div class="floating-thread-panel pinned-panel" [class.theme-light]="theme.isLight">
      <div class="panel-content pinned-panel-content">
        <app-chat
          [threadId]="pinnedThread.threadId"
          [inFloatingPanel]="true"
          [autofocusOnLoad]="true"
          class="pinned-chat-host d-flex flex-column flex-grow-1"
          style="min-height: 0;"
          [style.pointer-events]="'auto'">
        </app-chat>
      </div>
    </div>
  </div>
</div>

<!-- Floating Thread Containers -->
<div class="floating-threads-overlay">
  <!-- Backdrop for maximized threads -->
  <div class="maximize-backdrop" 
       *ngIf="hasMaximizedThread()" 
       (click)="onBackdropClick()"></div>
  
  <ng-container *ngFor="let thread of getOverlayThreads(); trackBy: trackByThreadId">
    <div 
      class="floating-thread-panel"
      [class.maximized]="thread.isMaximized"
      [class.theme-light]="theme.isLight"
      [style.left.px]="thread.position.x"
      [style.top.px]="thread.position.y"
      [style.width.px]="thread.size.width"
      [style.height.px]="thread.size.height"
      [style.z-index]="thread.zIndex"
      (mousedown)="onFocusThread(thread.threadId)">
    
    <!-- Panel Header (moved from footer) -->
    <div class="panel-header" 
         [class.no-drag]="thread.isMaximized"
         [attr.data-thread-id]="thread.threadId"
         (mousedown)="onDragStart($event, thread.threadId)">
      
      <!-- Thread Info -->
      <div class="thread-info">
        <div class="thread-title">
          {{ getThreadTitle(thread.threadId) }}
        </div>
      </div>

      <!-- Panel Controls -->
      <div class="panel-controls">
        <button 
          class="control-btn close-btn"
          (click)="onCloseThread(thread.threadId)"
          (mousedown)="$event.stopPropagation()"
          [uiTooltip]="'Close'"
          uiTooltipPlacement="top"
          [uiTooltipSuppressOnMobile]="true">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Panel Content (Chat Area) -->
    <div class="panel-content">
      
      <!-- Chat Component -->
      <app-chat 
        [threadId]="thread.threadId"
        [inFloatingPanel]="true"
        [autofocusOnLoad]="true"
        [style.pointer-events]="'auto'">
      </app-chat>
      
    </div>

    <!-- Resize Handles -->
    <div class="resize-handles" *ngIf="!thread.isMaximized && thread.displayMode !== 'pinned'">
      <!-- Corner handles -->
      <div class="resize-handle nw" (mousedown)="onResizeStart($event, thread.threadId, 'nw')"></div>
      <div class="resize-handle ne" (mousedown)="onResizeStart($event, thread.threadId, 'ne')"></div>
      <div class="resize-handle sw" (mousedown)="onResizeStart($event, thread.threadId, 'sw')"></div>
      <div class="resize-handle se" (mousedown)="onResizeStart($event, thread.threadId, 'se')"></div>
      
      <!-- Edge handles -->
      <div class="resize-handle n" (mousedown)="onResizeStart($event, thread.threadId, 'n')"></div>
      <div class="resize-handle s" (mousedown)="onResizeStart($event, thread.threadId, 's')"></div>
      <div class="resize-handle e" (mousedown)="onResizeStart($event, thread.threadId, 'e')"></div>
      <div class="resize-handle w" (mousedown)="onResizeStart($event, thread.threadId, 'w')"></div>
    </div>
    </div>
  </ng-container>
</div>
